/*
 * @Author: limin
 * @Date: 2019-08-26 18:02:55
 * @Last Modified by: chenwq
 * @Last Modified time: 2020-12-01 10:44:09
 */

import request from "./request"
import RequestMethods from "./request.methods"
// 用户相关
const USER_PATH = "dj.api."
// 角色相关
const ROLE_PATH = "fims.role."

export const LOGIN_URL = `${USER_PATH}user.login`
export const REG_URL = `${USER_PATH}register`
export const ROLE_LIST_URL = `${ROLE_PATH}list`

/**
 * 用户登录
 * @param {*} data 参数
 */
export function AccountLogin(data) {
  data.method = LOGIN_URL
  return request(data)
  // return new Promise(resolve => {
  //   resolve({
  //     roleId: 7,
  //     roleType: 2,
  //     mobile: '15234057707',
  //     userName: 'wxw',
  //     loginName: 'foutouren',
  //     authes: []
  //     // authes: [{
  //     //   authId: '10101',
  //     //   parentId: '101'
  //     // }, {
  //     //   authId: '102',
  //     //   parentId: '0'
  //     // }]
  //   })
  // })
}

// 选择账号
export function selectAccount(data) {
  data.method = `${USER_PATH}user.login.select`
  return request(data)
}

// 权限
export function getAuths(data) {
  data.method = `${USER_PATH}userauth.getUserAuth`
  return request(data)
}

// 用户信息
export function getUserInfo(data) {
  data.method = `${USER_PATH}user.info`
  return request(data)
}

/**
 * 注册
 * @param {*} data 参数
 */
export function Reg(data = {}) {
  data.method = REG_URL
  return request(data, RequestMethods.GET)
}

/**
 * 修改密码
 * @param {*} data
 */
export function ModifyPassword(data) {
  data.method = `${USER_PATH}password.modify`
  return request(data, RequestMethods.POST)
}

/**
 * 获取用户列表
 * @param {*} data 参数
 */
export function UserList(data = {}) {
  data.method = `${USER_PATH}search`
  return request(data, RequestMethods.GET)
}

/**
 * 重置密码
 * @param {*} data 参数
 */
export function PassWordReset(data = {}) {
  // ok--
  data.method = `${USER_PATH}password.reset`
  return request(data, RequestMethods.GET)
}

/**
 * 帐户编辑
 * @param {*} data 参数
 */
export function AccountModify(data = {}) {
  data.method = `${USER_PATH}modify`
  return request(data, RequestMethods.GET)
}

/**
 * 帐户延期
 * @param {*} data 参数
 */
export function AccountIncrease(data = {}) {
  // ok--
  data.method = `${USER_PATH}validity.increase`
  return request(data, RequestMethods.GET)
}

/**
 * 帐户禁用
 * @param {*} data 参数
 */
export function AccountForbidden(data = {}) {
  // ok--
  data.method = `${USER_PATH}forbidden`
  return request(data, RequestMethods.GET)
}

/**
 * 帐户激活
 * @param {*} data 参数
 */
export function AccountActived(data = {}) {
  // ok--
  data.method = `${USER_PATH}actived`
  return request(data, RequestMethods.GET)
}

/**
 * 帐户审核
 * @param {*} data 参数
 */
export function AccountValidate(data = {}) {
  data.method = `${USER_PATH}check`
  return request(data, RequestMethods.GET)
}

/**
 * 获取登录日志
 * @param {} data
 */
export function getLoginlogs(data) {
  data.method = `${USER_PATH}search.loginlog`
  return request(data)
}

/**
 * 获取角色权限资源列表
 * @param {*} data 参数
 */
export function RoleAuthData(data = {}) {
  data.method = `${ROLE_PATH}authority.data`
  return request(data, RequestMethods.GET)
}

/**
 * 创建角色
 * @param {*} data 参数
 */
export function RoleReg(data = {}) {
  // ok--
  data.method = `${ROLE_PATH}register`
  return request(data, RequestMethods.GET)
}

/**
 * 权限修改
 * @param {*} data 参数
 */
export function RoleModify(data = {}) {
  // ok--
  data.method = `${ROLE_PATH}modify`
  return request(data, RequestMethods.GET)
}

/**
 * 权限列表
 * @param {*} data 参数
 */
export function RoleList(data = {}) {
  data.method = ROLE_LIST_URL
  return request(data, RequestMethods.GET)
}

/**
 * 角色详情
 * @param {*} data 参数
 */
export function RoleDetail(data = {}) {
  data.method = `${ROLE_PATH}detail`
  return request(data, RequestMethods.GET)
}

/**
 * scrm账号登录
 * @param {*} data 参数
 */
export function scrmLogin(data = {}) {
  data.method = `scrm.api.sso.user.loginCode`
  return request(data, RequestMethods.POST)
}
/**
 * 账户中心账号登录
 * @param {*} data 参数
 */
export function ssoLogin(data = {}) {
  data.method = `ssoCenter.api.cas.api.login`
  return request(data, RequestMethods.POST)
}
